import AmountToPayStore from "core/stores/amount-to-pay.store";
import AmountToPayStoreManager from "core/stores/amount-to-pay.store.manager";
import BusinessDetailsStore from "core/stores/business-details.store";
import BusinessDetailsStoreManager from "core/stores/business-details.store.manager";
import FreshDeskStore from "core/stores/fresh-desk.store";
import InboxStore from "core/stores/inbox.store";
import InboxStoreManager from "core/stores/inbox.store.manager";
import LatestStatementsStore from "core/stores/latest-statements.store";
import LatestStatementsStoreManager from "core/stores/latest-statements.store.manager";
import StatementsAndInvoicesStore from "core/stores/statements-and-invoices.store";
import StatementsAndInvoicesStoreManager from "core/stores/statements-and-invoices.store.manager";
import SubscriptionStore from "core/stores/subscriptions.store";
import SubscriptionStoreManager from "core/stores/subscriptions.store.manager";
import TicketStore from "core/stores/ticket.store";
import TicketStoreManager from "core/stores/ticket.store.manager";
import ClearErrorStore from "self-service/dashboard/clear-error/clear-error.store";
import ClearErrorStoreManager from "self-service/dashboard/clear-error/clear-error.store.manager";

//This is was just added when trying to get to the bottom of a HTML 
//not re-rendering. Did move that out to a separate component which fixed the issue
//but leaving this hear for now.
export type OnPopulate = {
    error?: any;
}

export class SelfServiceStores {
    subscriptions = new SubscriptionStore();
    freshDesk = new FreshDeskStore();
    businessDetails = new BusinessDetailsStore();
    amountToPay = new AmountToPayStore();
    latestStatement = new LatestStatementsStore();
    clearError = new ClearErrorStore();
    tickets = new TicketStore();
    statements = new StatementsAndInvoicesStore();
    inbox = new InboxStore(7);
}

export class SelfServiceManagers {
    private _stores: SelfServiceStores;
    subscriptions: SubscriptionStoreManager;
    businessDetails: BusinessDetailsStoreManager;
    amountToPay: AmountToPayStoreManager;
    latestStatement: LatestStatementsStoreManager;
    clearError: ClearErrorStoreManager;
    statements: StatementsAndInvoicesStoreManager;
    inbox: InboxStoreManager;

    get tickets() {
        return new TicketStoreManager(this._stores.freshDesk.contact, this._stores.tickets);
    }

    constructor(stores: SelfServiceStores) {
        this.subscriptions = new SubscriptionStoreManager(stores.subscriptions);
        this.businessDetails = new BusinessDetailsStoreManager(stores.businessDetails);
        this.amountToPay = new AmountToPayStoreManager(stores.amountToPay);
        this.latestStatement = new LatestStatementsStoreManager(stores.latestStatement);
        this.clearError = new ClearErrorStoreManager(stores.clearError);
        this.statements = new StatementsAndInvoicesStoreManager(stores.statements);
        this.inbox = new InboxStoreManager(stores.inbox);

        this._stores = stores;
    }

    reset() {
        this.subscriptions.reset();
        this.businessDetails.reset();
        this.amountToPay.reset();
        this.latestStatement.reset();
        this._stores.tickets.clear();
        this._stores.statements.clear();
        this.inbox.reset();
    }

    async populateAll(onPopulate: OnPopulate | undefined = undefined) {
        const t1 = this.subscriptions.populateAsync();
        const t2 = this.businessDetails.populateAsync();
        const t3 = this.amountToPay.populateAsync(onPopulate);
        const t4 = this.latestStatement.populateAsync();
        const t5 = this.clearError.fetchCodesAsync();
        const t6 = this.inbox.populateAsync();

        await t1;
        await t2;
        await t3;
        await t4;
        await t5;
        await t6;
    }
}

class SelfServiceController {
    stores = new SelfServiceStores();
    managers: SelfServiceManagers;

    constructor() {
        this.managers = new SelfServiceManagers(this.stores);
    }

    reset() {
        this.managers.reset();
    }

    populateAll(onPopulate: OnPopulate | undefined = undefined) {
        this.managers.populateAll(onPopulate);
    }
}

export default SelfServiceController;
